import { Controller } from "stimulus"

// Bugfix 32 (#1566): de verstreken trainingstijd (Duur), vanaf de eerste
// afgevinkte set. Zonder start blijft er een streepje staan.
export default class extends Controller {
  static values = { start: Number }

  connect() {
    if (!(this.startValue > 0)) return
    this.tik()
    this.timer = setInterval(() => this.tik(), 1000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  tik() {
    const s = Math.max(0, Math.floor(Date.now() / 1000 - this.startValue))
    const u = Math.floor(s / 3600)
    const m = Math.floor((s % 3600) / 60)
    const r = String(s % 60).padStart(2, "0")
    this.element.textContent = u > 0 ? `${u}:${String(m).padStart(2, "0")}:${r}` : `${m}:${r}`
  }
}
